<template>
  <div>
    <div class="uk-container uk-margin-small-top">
      <h2 class="uk-heading-small uk-text-center">Upload Images</h2>
      <p
        class="uk-text-center uk-width-1-2@m uk-align-center"
      >Upload any images that might help us with your design.</p>
      <progress
        class="uk-progress uk-width-1-2@m uk-align-center"
        :value="onboardingConfig.completedSteps"
        :max="onboardingConfig.totalSteps"
      ></progress>
      <div class="js-upload uk-align-center" v-if="!uploading" uk-form-custom>
        <input type="file" @change="onFilePicked" />
        <button class="uk-button uk-button-default uk-align-center" type="button" tabindex="-1">
          <span class="uk-margin-small-right" uk-icon="upload" v-if="!uploading"></span>Select a File
        </button>
      </div>
      <button
        class="uk-button uk-button-default uk-align-center"
        type="button"
        tabindex="-1"
        v-if="uploading"
        disabled
      >
        <div uk-spinner></div>
        Uploading ({{uploadProgress}}%)
      </button>
      <p
        class="uk-text-center uk-width-1-2@m uk-align-center uk-margin-small-top uk-text-warning"
        v-if="badExtension"
      >File must be .ai, .eps, .svg, .pdf, .png, or .jpg</p>
      <div class="uk-child-width-1-2 uk-child-width-1-4@m" uk-grid="masonry: true">
        <div v-for="(file, index) in tempUploadedFiles">
          <div class="uk-card uk-card-default uk-card-small" id="card">
            <div class="uk-card-media-top" uk-toggle="target: #zoom-image">
              <a href="#">
                <img v-if="file.canPreview" :src="file.downloadURL" alt />
                <img v-if="!file.canPreview" src="../../assets/preview-not-available.jpg" alt />
              </a>
            </div>
            <div class="uk-card-body">
              <p class="uk-margin-small uk-text-muted">{{file.originalName | truncate(25)}}</p>
              <button
                class="uk-button uk-button-default uk-width-1-1"
                v-on:click="removeFile(index)"
              >remove</button>
            </div>
          </div>
        </div>
      </div>
      <div class="uk-width-1-2 uk-align-center">
        <div class="uk-child-width-1-2" uk-grid>
          <div>
            <router-link to="/new-project/wed/select-colors">
              <button class="uk-button uk-button-default uk-width-1-1">Go Back</button>
            </router-link>
          </div>
          <div>
            <router-link to="/new-project/wed/confirm">
              <button class="uk-button uk-button-primary uk-width-1-1">Continue</button>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UIkit from "uikit";
import OrgPatternService from "@/services/OrgPatternService";
import firebase from "firebase";
import _ from "lodash";

export default {
  name: "UploadWedImage",
  data() {
    return {
      onboardingConfig: {
        formType: "organization",
        completedSteps: 2,
        totalSteps: 3,
        image: null
      },
      tempUploadedFiles: [],
      badExtension: false,
      uploading: false,
      uploadProgress: 0
    };
  },
  methods: {
    removeFile(index) {
      this.tempUploadedFiles.splice(index, 1);
    },
    onFilePicked(event) {
      var self = this;
      self.badExtension = false;
      let fileDeatils = {
        originalName: "",
        newName: "",
        extension: "",
        downloadURL: "",
        canPreview: false
      };
      const files = event.target.files;
      let filename = files[0].name;
      fileDeatils.originalName = filename;
      if (filename.lastIndexOf(".") <= 0) {
        return alert("Please add a valid file!");
      }

      let splitFileName = _.split(filename, ".");
      let filenameNoExtension = "";
      let extension = "";
      if (splitFileName.length == 2) {
        filenameNoExtension = splitFileName[0];
        extension = splitFileName[1];
      } else {
        for (let index = 0; index < splitFileName.length - 1; index++) {
          const element = splitFileName[index];
          filenameNoExtension = filenameNoExtension.concat(element);
          if (index < splitFileName.length - 1) {
            filenameNoExtension.concat(".");
          }
        }
        extension = splitFileName[splitFileName.length - 1];
      }
      fileDeatils.extension = extension;

      if (!["ai", "svg", "eps", "png", "jpg", "pdf"].includes(extension)) {
        self.badExtension = true;
        return;
      }

      if (["svg", "png", "jpg"].includes(extension)) {
        fileDeatils.canPreview = true;
      }

      //firebase example
      let storageRef = firebase.storage().ref();
      let newName =
        filenameNoExtension + _.random(100000, 999999) + "." + extension;
      fileDeatils.newName = newName;
      let imageRef = storageRef.child("org-uploads/" + newName);
      let file = files[0];
      let uploadTask = imageRef.put(file);
      // Listen for state changes, errors, and completion of the upload.
      uploadTask.on(
        firebase.storage.TaskEvent.STATE_CHANGED, // or 'state_changed'
        function(snapshot) {
          // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
          let progress = Math.round(
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100
          );
          self.uploadProgress = progress;
          switch (snapshot.state) {
            case firebase.storage.TaskState.PAUSED: // or 'paused'
              console.log("Upload is paused");
              break;
            case firebase.storage.TaskState.RUNNING: // or 'running'
              console.log("Upload is running");
              self.uploading = true;
              break;
          }
        },
        function(error) {
          console.log(error.code);
        },
        function() {
          // Upload completed successfully, now we can get the download URL
          uploadTask.snapshot.ref.getDownloadURL().then(function(downloadURL) {
            self.uploading = false;
            self.uploadProgress = 0;
            fileDeatils.downloadURL = downloadURL;
            self.tempUploadedFiles.push(fileDeatils);
          });
        }
      );
    }
  },
  filters: {
    truncate: function(value, limit) {
      if (value.length > limit) {
        value = value.substring(0, limit - 3) + "...";
      }
      return value;
    }
  },
  computed: {
    uploadedFiles() {
      return this.$store.state.newWedProject.uploadedFiles.files;
    },
    isActive() {
      return this.$store.state.newWedProject.isActive;
    }
  },
  mounted: function() {
    if (!this.isActive) {
      this.$router.push({ name: "CreateWedProject" });
    }
    if (this.$store.state.newWedProject.uploadedFiles.saved == true) {
      this.tempUploadedFiles = JSON.parse(JSON.stringify(this.uploadedFiles));
    }
  },
  watch: {
    tempUploadedFiles() {
      this.$store.commit(
        "newWedProject/setUploadedFiles",
        this.tempUploadedFiles
      );
    }
  }
};
</script>

<style type="text/css">
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/wed-onboarding/UploadWedImage.vue